import { postRequest } from 'services/requests';

const services = {
    createSetupIntent: (customerId, body) => postRequest(`/stripe/customers/${customerId}/setup-intents`, body),
    updateSubscription: (customerId, subscriptionId, body) => {
        return postRequest(`/stripe/customers/${customerId}/subscriptions/${subscriptionId}`, body);
    },
    detachDefaultPaymentMethod: (customerId) => {
        return postRequest(`/stripe/customers/${customerId}/payment-methods`);
    },
};

export default services;
